export const CrossIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    className="h-5 w-5">
    <path
      d="M11.5988 9.0005L16.4712 4.12803C17.0096 3.58967 17.0096 2.71686 16.4712 2.17934L15.8217 1.52978C15.2831 0.991252 14.4103 0.991252 13.8728 1.52978L9.0005 6.40209L4.12803 1.52877C3.58967 0.99041 2.71686 0.99041 2.17934 1.52877L1.52877 2.17833C0.99041 2.71686 0.99041 3.58967 1.52877 4.12719L6.40209 9.0005L1.52978 13.8728C0.991252 14.4113 0.991252 15.2842 1.52978 15.8217L2.17934 16.4712C2.7177 17.0096 3.59051 17.0096 4.12803 16.4712L9.0005 11.5988L13.8728 16.4712C14.4113 17.0096 15.2842 17.0096 15.8217 16.4712L16.4712 15.8217C17.0096 15.2831 17.0096 14.4103 16.4712 13.8728L11.5988 9.0005Z"
      fill="white"
    />
  </svg>
);
